<script setup lang="ts">

const route = useRoute()

const showDowngrade = computed(() => route.query.action === 'downgrade')
const showChange = computed(() => route.query.action === 'change')
const showBuy = computed(() => route.query.action === 'buy')

</script>
<template>
  <v-row v-if="showDowngrade || showBuy || showChange">
    <v-col>
      <v-alert v-if="showDowngrade" color="success" icon="mdi-information" variant="tonal">
        The downgrade of your {{ route.query.plan }} plan has successfully been executed. You have been credited the
        price of the remaining
        days in your subscription period.
      </v-alert>
      <v-alert v-if="showBuy" color="success" icon="mdi-information" variant="tonal">
        Your {{ route.query.plan }} Plan has been successfully activated. You can now follow the
        installation instructions
        to set up your Axon Server cluster.
      </v-alert>
      <v-alert v-if="showChange" color="success" icon="mdi-information" variant="tonal">
        The amount of connections for your {{ route.query.plan }} plan has been updated to {{
          route.query.connections
        }}.
      </v-alert>
    </v-col>
  </v-row>
</template>
